import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {PanelMenu} from 'primereact/components/panelmenu/PanelMenu';
import {Button} from 'primereact/components/button/Button';
import './navbar.css';

export default class Navbar extends Component {
    static propTypes = {
        model: PropTypes.array,
        logoSrc: PropTypes.string,
        toogleWidth: PropTypes.number
    };

    state = {
        showPanel: false,
        activeMenu: null
    };

    renderCustomContent() {
        return this.props.children ? (
            <div className="navbar-custom">
                {this.props.children}
            </div>
        ) : null;
    }

    openMenu = (index) => {
        this.setState({activeMenu: index});
    };

    closeMenu = () => {
        this.setState({activeMenu: null});
    };

    renderMegaMenu(item) {
        if (!item.items || !item.items.length) {
            return null;
        }

        return (
            <div className="mega-menu" >
                <div className="mega-menu-grid">
                    {item.items.map((section, index) => (
                        <div className="mega-menu-column" key={index}>
                            <div className="mega-menu-heading">
                                {section.label}
                            </div>

                            <div className="mega-menu-divider"/>

                            {section.items && section.items.map((link, linkIndex) => (
                                <a
                                    className="mega-menu-link"
                                    href={link.url}
                                    key={linkIndex}
                                >
                                    {link.label}
                                </a>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    renderDesktop() {
        const model = this.props.model || [];

        return (
            <div
                className="desktop"
                onMouseLeave={this.closeMenu}
            >
                <div className="navbar-menu">
                    {model.map((item, index) => (
                        <div
                            className={
                                'navbar-menu-item' +
                                (this.state.activeMenu === index ? ' active' : '')
                            }
                            key={index}
                            onMouseEnter={() => this.openMenu(index)}
                        >
                            <a
                                className="navbar-menu-label"
                                href={item.url || '#'}
                            >
                                {item.label}
                            </a>

                            {this.state.activeMenu === index &&
                                this.renderMegaMenu(item)}
                        </div>
                    ))}
                </div>

                {this.renderCustomContent()}
            </div>
        );
    }

    renderMobile() {
        return (
            <div className="mobile">
                <div style={{display: 'flex'}}>
                    <Button
                        icon="fa fa-bars"
                        className="ui-button-secondary"
                        onClick={() =>
                            this.setState({
                                showPanel: !this.state.showPanel
                            })
                        }
                    />
                    {this.renderCustomContent()}
                </div>

                {this.state.showPanel ? (
                    <PanelMenu {...this.props}/>
                ) : null}
            </div>
        );
    }

    render() {
        const toogleWidth = this.props.toogleWidth || 500;

        return (
            <div className="navbar">
                {window.innerWidth < toogleWidth
                    ? this.renderMobile()
                    : this.renderDesktop()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/site_interfaces/navbar.js